/* ROVIXO GO: color sets and the existing two-bag picker, scoped to its product-info. */
(() => {
  const normalize = (value) => String(value || '').trim().toLowerCase();
  const aliases = { 'שחור': 'black', 'כחול': 'blue', 'אפור': 'grey', gray: 'grey', 'ורוד': 'pink', 'סגול': 'purple' };
  const colorKey = (value) => aliases[normalize(value)] || normalize(value);
  function mediaKey(media) {
    const tag = normalize(media.alt).match(/(?:^|\s)rovixo-(black|blue|grey|gray|pink|purple)(?=$|\s)/);
    if (tag) return colorKey(tag[1]);
    const file = decodeURIComponent((media.src || '').split('?')[0].split('/').pop());
    const match = file.match(/^(black|blue|grey|gray|pink|purple)(?=\d|[_. -]|$)/i);
    return match ? colorKey(match[1]) : null;
  }
  function init(root) {
    if (root.dataset.ready) return;
    const info = root.closest('product-info');
    const gallery = info?.querySelector('media-gallery');
    const c1 = root.querySelector('.bp-color1');
    if (!info || !gallery || !c1) return;
    root.dataset.ready = 'true';
    const variants = JSON.parse(document.getElementById(`${root.id}-v`).textContent);
    const media = JSON.parse(document.getElementById(`${root.id}-m`).textContent);
    const cIdx = Number(c1.dataset.i);
    const box2 = root.querySelector('.bp-color2');
    const prop = 'properties[צבע תיק שני]';
    let selected = [];
    root.querySelectorAll('.bp-g[data-i]').forEach(group => {
      selected[Number(group.dataset.i)] = (group.querySelector('.on') || group.querySelector('button')).dataset.v;
    });
    let second = selected[cIdx];
    let preview = selected[cIdx];
    let lastPreview;
    const match = options => variants.find(v => options.every((value, index) => v.options[index] === value));
    const duo = () => !!root.querySelector('.bp-card.on.best');
    function syncProp() {
      info.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
        let input = form.querySelector(`input[name="${prop}"]`);
        if (duo() && box2) {
          if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = prop; form.append(input); }
          input.value = second;
        } else input?.remove();
      });
    }
    function refresh() {
      root.querySelectorAll('button[data-i]').forEach(button => {
        const index = Number(button.dataset.i), options = selected.slice();
        options[index] = button.dataset.v;
        const variant = match(options);
        const on = selected[index] === button.dataset.v;
        button.classList.toggle('on', on);
        button.setAttribute('aria-pressed', String(on));
        button.classList.toggle('off', !variant?.available);
        button.disabled = !variant?.available;
      });
      root.querySelectorAll('[data-sel]').forEach(label => { label.textContent = selected[Number(label.closest('.bp-g').dataset.i)]; });
      root.classList.toggle('duo', duo());
      if (box2) {
        box2.hidden = !duo();
        c1.querySelector('[data-t]').textContent = duo() ? 'צבע תיק ראשון:' : 'בחרו צבע:';
        box2.querySelector('[data-sel2]').textContent = second;
        box2.querySelectorAll('button').forEach(button => {
          const available = variants.some(v => v.available && v.options[cIdx] === button.dataset.v);
          button.classList.toggle('on', button.dataset.v === second);
          button.setAttribute('aria-pressed', String(button.dataset.v === second));
          button.classList.toggle('off', !available);
          button.disabled = !available;
        });
      }
      syncProp();
    }
    function applyGallery() {
      const key = colorKey(preview);
      const matching = media.filter(item => mediaKey(item) === key);
      // Unclassified media (e.g. a shared demo video) remain available to every color.
      // If no set is identified, leave the gallery usable rather than hiding everything.
      const allowed = new Set((matching.length ? media.filter(item => !mediaKey(item) || mediaKey(item) === key) : media).map(item => String(item.id)));
      const idOf = element => (element.dataset.mediaId || element.dataset.target).split('-').pop();
      const slides = [...gallery.querySelectorAll('[id^="Slider-Gallery"] > [data-media-id]')];
      gallery.querySelectorAll('[data-media-id], [data-target]').forEach(element => {
        element.classList.toggle('rovixo-media-hidden', !allowed.has(idOf(element)));
      });
      info.querySelectorAll('product-modal [data-media-id]').forEach(element => {
        element.classList.toggle('rovixo-media-hidden', !allowed.has(idOf(element)));
      });
      const active = slides.find(element => element.classList.contains('is-active') && allowed.has(idOf(element)));
      const first = matching[0] && slides.find(element => idOf(element) === String(matching[0].id));
      const target = lastPreview === preview && active ? active : first || slides.find(element => allowed.has(idOf(element)));
      if (!target) return;
      // Keep product media order stable: changing quantity must not jump to another image.
      slides.forEach(element => element.classList.toggle('is-active', element === target));
      gallery.querySelectorAll('slider-component').forEach(slider => slider.resetPages?.());
      if (lastPreview !== preview || !active) {
        gallery.setActiveMedia?.(target.dataset.mediaId, false, { preventPageScroll: true });
        if (lastPreview !== undefined && lastPreview !== preview && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          target.animate?.([{ opacity: 0.4 }, { opacity: 1 }], { duration: 220, easing: 'ease-out' });
        }
      }
      lastPreview = preview;
    }
    function selectNative(index, value) {
      const picker = info.querySelector('variant-selects');
      if (!picker) return false;
      const groups = [...picker.querySelectorAll('.product-form__input')];
      const group = groups[index];
      const radio = [...(group?.querySelectorAll('input[type="radio"]') || [])].find(input => input.value === value);
      if (radio) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); return true; }
      const select = group?.querySelector('select');
      if (select) { select.value = value; select.dispatchEvent(new Event('change', { bubbles: true })); return true; }
      return false;
    }
    info.rovixoPicker = { applyGallery };
    root.addEventListener('click', event => {
      const button = event.target.closest('button');
      if (!button || button.disabled) return;
      if (button.dataset.i === undefined) {
        second = button.dataset.v; preview = second; refresh(); applyGallery(); return;
      }
      const index = Number(button.dataset.i), next = selected.slice();
      next[index] = button.dataset.v;
      if (!match(next)?.available) return;
      selected = next;
      if (index === cIdx || !button.closest('.bp-color1') && !button.classList.contains('best')) preview = selected[cIdx];
      refresh(); applyGallery(); selectNative(index, button.dataset.v);
    });
    // Dawn owns form IDs, price, availability and URL; never overwrite them with a timer.
    const unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      if (String(data.sectionId) !== info.dataset.section || !root.isConnected) return;
      selected = data.variant.options.slice(); refresh(); applyGallery();
    });
    info.addEventListener('submit', syncProp, true);
    const unload = event => {
      if (event.target.contains(root)) { unsubscribe(); document.removeEventListener('shopify:section:unload', unload); }
    };
    document.addEventListener('shopify:section:unload', unload);
    refresh(); applyGallery();
    const params = new URLSearchParams(location.search);
    if (!params.has('variant') && !params.has('option_values')) {
      const next = selected.slice();
      const black = variants.find(v => v.available && colorKey(v.options[cIdx]) === 'black' && v.options.every((value, index) => index === cIdx || value === selected[index]));
      if (black && selected[cIdx] !== black.options[cIdx]) {
        next[cIdx] = black.options[cIdx]; selected = next; second = next[cIdx]; preview = next[cIdx];
        refresh(); applyGallery(); selectNative(cIdx, next[cIdx]);
      }
    }
  }
  function mount(scope) { scope.querySelectorAll('[data-rovixo-picker]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(document));
  else mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
